<template>
  <div>
    <v-card
      color="primary"
      dark
    >
      <v-card-text class="pt-0">
        <v-checkbox
          v-model="cerradas"
          label="Mostrar cuentas cerradas"
          hide-details
          class="mt-0"
        ></v-checkbox>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
export default {
  name: 'CerradasFilterComponent',
  data () {
    return {
      //
    }
  },
  computed: {
    ...mapGetters('Cuentas', ['filters']),
    cerradas: {
      get () {
        return this.filters.cerradas == 1 ? true : false
      },
      set (value) {
        this.setFilters({
          ...this.filters,
          cerradas: value ? 1 : 0
        })
      }
    },
  },
  methods: {
    ...mapMutations('Cuentas', ['setFilters'])
  },
}
</script>
